import React from "react";
import { Button } from "antd";
import {
  DownloadOutlined,
  UploadOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

const CONFIG = {
  download: {
    icon: <DownloadOutlined />,
    color: "#8A8A8A",
  },
  upload: {
    icon: <UploadOutlined />,
    color: "#8A8A8A",
  },
  delete: {
    icon: <DeleteOutlined />,
    color: "#E11011",
  },
  excel: {
    icon: <DownloadOutlined />,
    color: "#008AD1",
  },
};

const AppButton = ({
  type = "text",
  variant = "download",
  children,
  ...rest
}) => {
  const { icon, color } = CONFIG[variant] || {};
  return (
    <Button
      type={type}
      size="small"
      icon={icon}
      style={{
        color: color,
        fontFamily: '"Poppins", sans-serif',
        fontWeight: 400,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default AppButton;
